import { useContext } from "react";
import { PaymentContext } from "../context";

export function usePayment() {
  return useContext(PaymentContext);
}
